import {
  BankingTray,
  BankingTrayVariables,
} from "_graphql/queries/kek/__generated__/BankingTray";

import { getBankingTray } from "_graphql/kek/queries/offers.kek";
import { useQuery } from "@apollo/client";

export const useBankingTray = (variables: BankingTrayVariables) => {
  const { data, ...rest } = useQuery<BankingTray, BankingTrayVariables>(
    getBankingTray,
    {
      variables,
      notifyOnNetworkStatusChange: true,
      fetchPolicy: "network-only",
    }
  );

  return { items: data?.rows || [], count: data?.count || 0, ...rest };
};
